import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { HeaderStyle } from './headerStyle';
import Logo from '../assets/logo-branco.webp';

const Header = ({ isVideo, mediaSource }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isSimulacaoPage = location.pathname === '/video';

  return (
    <HeaderStyle>
      <header className="header__wrapper col-12">
        <div className="logo-box">
          <img ClassName="logo" src={Logo} alt="Logo" height={75} />
        </div>

        <div
          className={
            (isVideo && windowWidth >= 1024) || isSimulacaoPage
              ? 'video-box'
              : 'img-box'
          }
        >
          {(isVideo && windowWidth >= 1024) || isSimulacaoPage ? (
            <video
              className="video"
              src={mediaSource}
              width="1024"
              height="768"
              controls
              loop
              muted
            />
          ) : (
            <img
              className="media"
              src={mediaSource}
              alt="Header Media"
              width="800"
              height="400"
            />
          )}
        </div>
      </header>
    </HeaderStyle>
  );
};

export default Header;
